<template>
  <v-btn
    class="text-capitalize"
    color="#EC928E"
    flat
    prepend-icon="mdi-trash-can"
    rounded="xl"
    data-cy="delete-button"
    @click="deleteWithConfirmation()">
    {{ $t(`actions.confirmation.${props.message}.button`) }}
  </v-btn>
</template>

<script setup>
import { useConfirm, useSnackbar } from "vuetify-use-dialog";
import { useTranslation } from "i18next-vue";

const props = defineProps({
  deleteAction: {
    type: Function,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false
  },
  message: {
    type: String,
    default: "delete"
  },
  disabledMessage: {
    type: String,
    default: "deleteDisabled"
  }
});

const { t } = useTranslation();
const createConfirm = useConfirm();
const createSnackbar = useSnackbar();

const deleteWithConfirmation = () => {
  if (props.disabled) {
    createSnackbar({
      text: t("actions." + props.disabledMessage),
      showCloseButton: false,
      snackbarProps: { color: "error", timeout: 2000 }
    });
    return;
  }

  createConfirm({
    dialogProps: { width: 400 },
    cardProps: { color: "error" },
    title: t(`actions.confirmation.${props.message}.title`),
    content: t(`actions.confirmation.${props.message}.content`),
    confirmationText: t(`actions.confirmation.${props.message}.confirm`),
    cancellationText: t(`actions.confirmation.${props.message}.cancel`),
    cancellationButtonProps: { "data-cy": "delete-cancel-button" },
    confirmationButtonProps: { color: "warning", "data-cy": "delete-confirm-button" }
  }).then((confirm) => {
    if (confirm) {
      props.deleteAction();
      createSnackbar({
        text: t("actions.deleted"),
        showCloseButton: false,
        snackbarProps: { color: "error", timeout: 1000 }
      });
    }
  });
};
</script>
